













































import { Component, Vue, Prop } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { WordpressPluginDTO } from "../../Generated/ParticaAPI";

@Component(
	{
		name: "WordpressPluginForm",
		components: { ButtonList }
	})
export default class WordpressPluginForm extends ParticaBaseForm<WordpressPluginDTO> {

	private showpassword: boolean = false;

	private urlconfig =
		{
			props: {
				name: "url",
				placeholder: "Enter wordpress url",
				label: "Wordpress Url",
			} as FormFieldProps,
			rules: { required: true, max: 200, min: 10, url: true } as FormFieldRules
		} as IFormField;

	private userconfig =
		{
			props: {
				name: "user",
				placeholder: "Enter Wordpress username",
				label: "Wordpress Username",
			} as FormFieldProps,
			rules: { required: true, max: 50, min: 3, } as FormFieldRules
		} as IFormField;

	private passwordconfig =
		{
			props: {
				name: "password",
				placeholder: "Enter wordpress password",
				label: "Wordpress password",
			} as FormFieldProps,
			rules: { required: true, max: 100, min: 6 } as FormFieldRules
		} as IFormField;

	private publishStatusconfig =
		{
			props: {
				name: "status",
				placeholder: "Choose publish status",
				label: "Publish status", required: true, values: [{ label: "Draft", value: "draft" } as EnumDTO, { label: "Publish", value: "publish" } as EnumDTO,],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

}
